export default __webpack_public_path__ + "assets/webgl/ray_line.6d9e33a3.png";